/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Option_FailInputs */



/**
* | output |
* | --- |
* | "Fail" |
*
* @param {Work_Order_Publish_Option_FailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_option_fail = /** @type {((inputs?: Work_Order_Publish_Option_FailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Option_FailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scheitern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fallire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неудача")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fallar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("失敗")
	if (locale === "hi") return /** @type {LocalizedString} */ ("असफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falhar")
	return /** @type {LocalizedString} */ ("Fail")
});